/** Barre compacte stock/cible pour une cellule de tableau (0% à 100%+, plafonnée visuellement à 100%). */
export function Sparkbar({ stock, target }: { stock: number; target: number }) {
  if (target <= 0) return <span className="muted">—</span>;
  const pct = Math.round((stock / target) * 100);
  const width = Math.max(3, Math.min(100, pct));
  const color = pct < 50 ? 'var(--danger)' : pct < 100 ? 'var(--warning)' : 'var(--success)';
  return (
    <div className="sparkbar-wrap" title={`${stock} / ${target} (cible)`}>
      <div className="sparkbar"><span style={{ width: `${width}%`, background: color }} /></div>
      <span className="sparkbar-pct">{pct}%</span>
    </div>
  );
}
